import { PlessUploadServiceSub } from '../../../../commons/kymw00/pless-upload-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * W掲載リストアップロード
 *
 * @export
 * @class UploadWPlaceListService
 * @extends {PlessUploadServiceSub}
 */
@Injectable()
export class UploadWPlaceListService extends PlessJsonUploadServiceSub<any> {

  private nextFunc: Function;
  vo = {
    OrderCode: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UploadWPlaceListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UploadWPlaceListService
   */
  execute(file: File, vo: any, nextFunc: Function): void {
    this.nextFunc = nextFunc;
    this.vo = vo;
    this.sendFile('uploadWPlaceList', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UploadWPlaceListService
   */
  success(data: any) {
    this.nextFunc(data);
  }
}
